<template>
  <div class="modal-wrapper">
    <div class="modal-dialog modal-lg" role="document">
      <div class="modal-content modal-content--scrollable">
        <div class="modal-header">
          <button type="button" class="close" @click="$emit('close')" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
          <h4 class="modal-title">
            Transferir pagamento
          </h4>
        </div>
        <div class="modal-body modal-body--scrollable">
          <p>Pagamento para ser transferido</p>
          <table class="table table-striped table-bordered">
            <thead>
              <tr>
                <th class="table-centralized">
                  ID
                </th>
                <th class="table-centralized">
                  Status
                </th>
                <th class="table-centralized">
                  Método
                </th>
                <th class="table-centralized">
                  Valor
                </th>
                <th class="table-centralized">
                  Data de pagamento
                </th>
              </tr>
            </thead>
            <tbody>
              <tr class="table-centralized">
                <td>{{ selectedBillPayment.id }}</td>
                <td>{{ selectedBillPayment.translated_status }}</td>
                <td>{{ selectedBillPayment.translated_method_type }}</td>
                <td>{{ selectedBillPayment.full_value | formatCurrency }}</td>
                <td>{{ selectedBillPayment.paid_at | formatDate }}</td>
              </tr>
            </tbody>
          </table>
          <div v-if="bills.length === 0" class="centralized-horizontal modal-body">
            <p class="centralized-horizontal-item">
              Não há mensalidades passíveis de transferência para esse aluno.
            </p>
          </div>
          <div v-else>
            <p>Selecione uma ação para a mensalidade de destino</p>
            <select v-model="chainNewBill" class="form-control">
              <option v-for="(BillsActions, index) in targetBillsActions"
                      :value="BillsActions.value"
                      :key="index"
              >
                {{ BillsActions.text }}
              </option>
            </select>
            <p>Selecione a mensalidade que deve receber o pagamento</p>
            <table class="table table-striped table-bordered">
              <thead>
                <tr>
                  <th class="table-centralized"></th>
                  <th class="table-centralized">
                    ID
                  </th>
                  <th class="table-centralized">
                    Status
                  </th>
                  <th class="table-centralized">
                    Valor atual
                  </th>
                  <th class="table-centralized">
                    Vencimento
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="billToReceivePayment in bills" :key="billToReceivePayment.id" class="table-centralized">
                  <td>
                    <input v-model="selectedBillId" :value="billToReceivePayment.id" type="radio">
                  </td>
                  <td>{{ billToReceivePayment.id }}</td>
                  <td>{{ billToReceivePayment.translated_status }}</td>
                  <td>{{ billToReceivePayment.amount | formatCurrency }}</td>
                  <td>{{ billToReceivePayment.due_date | formatDate }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="modal-footer">
          <button
            class="btn btn-primary"
            @click="transferPayment"
            :disabled="!selectedBillId"
            :title="!canShowTransferButton(selectedBillId) ? 'Selecione a mensalidade de destino' : ''"
          >
            Transferir
          </button>
          <button class="btn btn-default" @click="$emit('close'), cleanStore()">
            Fechar
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import Permissions from 'mixins/Permissions';
import BillPaymentService from 'services/BillPaymentService';

export default {
  mixins: [Permissions],
  data() {
    return {
      selectedBillId: null,
      chainNewBill: true,
      targetBillsActions: [
        { value: true, text: 'Baixar mensalidade de destino' },
        { value: false, text: 'Não baixar mensalidade de destino' },
      ],
    };
  },
  computed: {
    ...mapState([
      'selectedBill',
      'studentBills',
      'selectedBillPayment',
    ]),
    bills() {
      return this.studentBills.filter((bill) => {
        const isDifferentBill = bill.id !== this.selectedBill.id;
        const isBillStatusValid = ['open', 'pending', 'overdue'].includes(bill.status);
        return isDifferentBill && isBillStatusValid;
      });
    },
  },
  methods: {
    ...mapActions([
      'loadStudentBills',
    ]),
    transferPayment() {
      this.$loader.show();
      BillPaymentService.transferPayment(this.selectedBillId, this.selectedBillPayment.id, this.chainNewBill)
        .then(() => {
          this.$emit('close', true);
          this.$alert.notifySuccess('Pagamento transferido com sucesso.');
          this.loadStudentBills().then(() => {
            this.$loader.hide();
          });
        })
        .catch(({ body }) => {
          this.$alert.notifyAlert(`Erro ao transferir o pagamento, contate o Suporte Graduação: ${body.message}`);
        })
        .finally(() => this.$loader.hide());
    },
    canShowTransferButton(selectedBillId) {
      return selectedBillId !== null;
    },
  },
};
</script>
